module.exports = __webpack_public_path__ + "static/img/news-20231027.43191f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20231027.png
// module id = Gy6H
// module chunks = 0